let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("j2Ov2")).then(() => parcelRequire('9owxV'));